<div class="glxy-page-nav-button--icon">
  <button
    mat-icon-button
    color="primary"
    matTooltip="{{ currentPreviousPageTitle() ? currentPreviousPageTitle() : '' }}"
    (click)="navigateToPreviousUrl()"
  >
    <mat-icon>arrow_back</mat-icon>
  </button>
</div>
